import axios from "axios";
import { url } from "../../../env";


export const functionGetResidualValues = async (logout) => {
    try {
        const token = localStorage.getItem('token');

        const res = await axios.get(`${url}/getResidualValues`, {
            headers: {
                "Authorization": `Bearer ${token}`,
            }
        });
        return res.data;
    } catch (err) {
        if (err.response && err.response.status === 401) {
            // Manejo del error 401
            // redirigir al usuario a la página de inicio de sesión
            /*       console.log('No autenticado. Redirigiendo a la página de inicio de sesión.'); */
            // Puedes redirigir al usuario aquí, por ejemplo:
            logout();
            window.location.href = '/login';
        } else {
            // Manejo de otros errores
            console.error('Error al obtener los valores residuales:', err);
        }
        return err.response ? err.response.data : { error: 'Error desconocido' };
    }
}

export const residualValsSubmit = async (values, logout) => {
    try {
        const token = localStorage.getItem('token');
        // setLoadingResidualValues(true);
        let params = Object.entries(values).map(([id, percentage]) => {
            return {
                "id": id,
                "percentage": parseFloat(percentage)
            };
        });

        const res = await axios.put(`${url}/updateResidualValues`, {
            updates: params
        }, {
            headers: {
                "Authorization": `Bearer ${token}`,
                // "Content-Type": 'application/json'
            }
        });
        // debugger
        // setLoadingResidualValues(false);
        return res;
    } catch (error) {
        return error;
        console.log(error);
    }
};


// paramsCalc

export const functionGetParamsCalc = async (logout) => {
    try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${url}/getCalcParams`, {
            headers: {
                "Authorization": `Bearer ${token}`,
            }
        });
        return res.data;
    } catch (err) {
        if (err.response && err.response.status === 401) {
            // Manejo del error 401
            // redirigir al usuario a la página de inicio de sesión
            console.log('No autenticado. Redirigiendo a la página de inicio de sesión.');
            // Puedes redirigir al usuario aquí, por ejemplo:
            logout();
            window.location.href = '/login';
        } else {
            // Manejo de otros errores
            console.error('Error al obtener los valores residuales:', err);
        }
        return err.response ? err.response.data : { error: 'Error desconocido' };
    }
}

export const updateParamsCalc = async (values) => {
    try {
        // setLoadingResidualValues(true);
        let params = Object.entries(values).map(([name_raw, val]) => {
            return {
                "name_raw": name_raw,
                "value": parseFloat(val)
            }
        })
        // debugger

        const res = await axios.put(`${url}/updateParamsCalc`, {
            updates: params
        }, {
            headers: {
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
                // "Content-Type": 'application/json'
            }
        });

        // setLoadingResidualValues(false);
        return res;
    } catch (error) {
        console.log(error);
    }
};

// paramsCalc

export const getManagementCosts = async (logout) => {
    try {
        const response = await axios.get(
            `${url}/managmentCosts`,
            {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json',
                }
            }
        )

        return response.data;
    }
    catch (err) {
        if (err.response && err.response.status === 401) {
            // Manejo del error 401
            // redirigir al usuario a la página de inicio de sesión
            console.log('No autenticado. Redirigiendo a la página de inicio de sesión.');
            // Puedes redirigir al usuario aquí, por ejemplo:
            logout();
            window.location.href = '/login';
        } else {
            // Manejo de otros errores
            console.error('Error al obtener los valores residuales:', err);
        }
        return err.response ? err.response.data : { error: 'Error desconocido' };
    }

}

export const updateManagementCosts = async (data) => {

    try {

        const response = await axios.put(
            `${url}/managmentCosts`,
            data,
            {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json',
                }
            }
        )

        return response;
    }
    catch (error) {
        console.log(error);
    }

}

//getFees

// export const getFees = async () => {
//     axios.get(`${url}/getFees`)
//         .then(res => {
//             debugger
//            return res.data;
//         })
//         .catch(e => {
//             //navigate("/");
//         });
// }

export const getFees = async (logout) => {
    try {
        const response = await axios.get(
            `${url}/getFees`,
            {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json',
                }
            }
        )

        return response.data;
    }
    catch (err) {
        if (err.response && err.response.status === 401) {
            // Manejo del error 401
            // redirigir al usuario a la página de inicio de sesión
            console.log('No autenticado. Redirigiendo a la página de inicio de sesión.');
            // Puedes redirigir al usuario aquí, por ejemplo:
            logout();
            window.location.href = '/login';
        } else {
            // Manejo de otros errores
            console.error('Error al obtener los valores residuales:', err);
        }
        return err.response ? err.response.data : { error: 'Error desconocido' };
    }

}

export const updateFees = async (data) => {
    try {

        const response = await axios.put(
            `${url}/updateFees`,
            {
                updates: data
            },
            {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json',
                }
            }
        )



        return response;
    } catch (error) {
        console.log(error);
    }

}

export const getStatePlates = async (logout) => {
    try {
        const response = await axios.get(
            `${url}/getStatePlates`,
            {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json',
                }
            }
        );

        return response.data;
    }
    catch (err) {
        if (err.response && err.response.status === 401) {
            logout();
            window.location.href = '/login';
        } else {
            console.error('Error al obtener los estados de placa:', err);
        }
        return err.response ? err.response.data : { error: 'Error desconocido' };
    }
};

export const updateStatePlates = async (updates) => {
    try {
        const response = await axios.put(
            `${url}/updateStatePlates`,
            { updates },
            {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json',
                }
            }
        );

        return response;
    } catch (error) {
        console.log(error);
    }
}


/* functions fecth para el admin Dashboards */

// Cache global para almacenar las categorías de usuarios ya consultados
let userCategoriesCache = {};

export const onChangePersonFetch = async (person, setSelectedPerson, setCategories, toast, url, axios) => {
    if (person) {
        setSelectedPerson(person);
        if (person.sections.length === 0) {
            toast?.current?.show({ severity: 'error', summary: 'Error', detail: 'El usuario no tiene documentos', life: 3000 });
            return;
        }

        try {
            // Determinar tipo de persona (pf o pm)
            const tipoPersona = person.tipo_persona === 'PF' ? 'pf' : 'pm';
            const userId = person.id;

            // Crear clave única para el cache
            const cacheKey = `${tipoPersona}_${userId}`;
            // Verificar si ya existe en el cache
            if (userCategoriesCache[cacheKey]) {
                setCategories(userCategoriesCache[cacheKey]);
                return;
            }


            // Obtener las categorías disponibles para esta persona
            const response = await axios.get(`${url}/api/pdfs/list/${tipoPersona}/${userId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
            const data = response.data;

            if (data.success) {
                // Guardar en cache
                userCategoriesCache[cacheKey] = data.data.categories;

                setCategories(data.data.categories);
            }
        } catch (error) {
            console.error('Error al obtener archivos:', error);
            toast?.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al cargar los documentos del usuario',
                life: 3000
            });
        }
    } else {
        toast?.current?.show({ severity: 'error', summary: 'Error', detail: 'Error al obtener usuario', life: 3000 });
        return;
    }
};

// Función para limpiar el cache si es necesario
export const clearUserCategoriesCache = () => {
    userCategoriesCache = {};
};

// Función para obtener el estado actual del cache
export const getUserCategoriesCache = () => {
    return userCategoriesCache;
};

